import React, { useEffect, useState, useMemo } from "react";
import CustomTable from "../CustomTable";
import { Button } from "react-bootstrap";
import Loading from "../utils/Loading";
import RecordCount from "../utils/RecordCount";

const Entities = (props) => {
  const [data, setData] = useState(props.entities);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!data) {
      const fetchData = async () => {
        try {
          const response = await fetch(props.get_entities_path, {
            headers: { Accept: "application/json" },
          });
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          const fetchedData = await response.json();
          setData(fetchedData);
        } catch (error) {
          console.log("Error fetching data: ", error);
        } finally {
          setIsLoading(false);
        }
      };
      if (!data || data.length === 0) {
        fetchData();
      } else {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  }, []);

  function entityLink(props, tableProps) {
    var entity_path = "/entities/" + tableProps.row.original.id;
    if (props.tab) {
      entity_path = entity_path + "?tab=" + props.tab;
    } else if (!tableProps.row.original.organization_id) {
      entity_path = entity_path + "?tab=validations";
    }
    return entity_path;
  }

  const columns = useMemo(
    () =>
      [
        {
          Header: "340B ID",
          accessor: "id_340b",
          filter: "fuzzyText",
          Cell: (tableProps) => (
            <a href={`/entities/${tableProps.row.original.id}`}>{tableProps.value}</a>
          ),
        },
        {
          Header: "Covered Entity",
          accessor: (row) =>
            `${row.entity_name} ${row.address1} ${row.city}, ${row.state}, ${row.designation_permitted_status}`,
          filter: "fuzzyText",
          Cell: (tableProps) => (
            <>
              <b>{tableProps.row.original.entity_name}</b>
              <br />
              <small className="text-muted">
                {tableProps.row.original.address1}, {tableProps.row.original.city},{" "}
                {tableProps.row.original.state}
              </small>
            </>
          ),
        },
        {
          Header: "Des Permitted Status",
          accessor: "designation_permitted_status",
          filter: "fuzzyText",
          Cell: (tableProps) => (
            <small className="text-muted badge bg-light">
              {tableProps.row.original.designation_permitted_status || "N/A"}
            </small>
          ),
        },
        {
          Header: "Registered",
          accessor: "registered",
          Cell: (row) => <>{row.value ? "True" : "False"}</>,
        },
        {
          Header: "Actions",
          id: "id",
          Filter: () => {},
          Cell: (tableProps) => (
            <div className="text-nowrap">
              <a href={entityLink(props, tableProps)}>
                <Button className="btn btn-sm btn-primary">View</Button>
              </a>
            </div>
          ),
        },
      ].filter((n) => n),
    []
  );

  return (
    <React.Fragment>
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {!props.hide_count ? <RecordCount record_count={data.length} /> : null}
          {data.length > 0 ? <CustomTable columns={columns} data={data} /> : null}
        </>
      )}
    </React.Fragment>
  );
};

export default Entities;
